import { useLocation, useNavigate } from "react-router-dom";
import PdfViewer from "../../../components/PDFViewer/PDFViewer";
import { ReactComponent as BackIcon } from "../../../images/back.svg";
import { Button } from "antd";
import { handleDownload } from "../../../common/Utilities";
import { FlooringSOAUrl } from "../../../common/Constants";

function ViewSOA() {
  const location = useLocation();
  const navigate = useNavigate();
  const State = location.state;
  const AppId = location.state?.appId;
  const AgentId = location.state?.AgentId;
  const StartDate = location.state?.start_date;
  const EndDate = location.state?.end_date;


  return (
    <section className="common_container">
      <header className="common-header flex justify-between flex-wrap gap-4">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3 flex-wrap">
            <span
              className="cursor-pointer"
              onClick={() => {
                navigate("/flooring-cases/view");
              }}
            >
              <BackIcon />
            </span>
            View SOA
          </h1>
        </div>
      </header>
      <section>
        <PdfViewer
          AppId={AppId}
          AgentId={AgentId}
          title="AAF Document"
          type="SOA"
          StartDate={StartDate}
          EndDate={EndDate}
        />
      </section>
      <footer className="footer-pdf-btn-block !justify-end">
        <Button type="submit" className="sav_btn"
          onClick={() => {
            handleDownload(
              `${FlooringSOAUrl}${AppId}/${StartDate}/${EndDate}`
            );
          }}
        >
          Download
        </Button>
      </footer>
    </section>
  );
}

export default ViewSOA;
